import {Component, OnInit} from '@angular/core';
import {ComponentHelper, FormBaseComponent, ValidationPattern, ValidatorService} from '@utils-lib';
import {AppNameEnum, Betriebstaette, LohnsteuerAngaben} from '@nachdigal';
import {FormBuilder} from '@angular/forms';
import {DatevMessageService} from '@datev/ngx-ui-components';
import {TranslateService} from '@ngx-translate/core';
import {ActivatedRoute} from '@angular/router';

@Component({
    selector: 'common-ui-voraussichtliche-lohnsteuer',
    templateUrl: './voraussichtliche-lohnsteuer.component.html',
    styleUrls: ['./voraussichtliche-lohnsteuer.component.scss']
})
export class VoraussichtlicheLohnsteuerComponent extends FormBaseComponent<LohnsteuerAngaben> implements OnInit {

    public betriebstaetten: Array<Betriebstaette> = [];

    public titel: string;
    public hinweis: string;
    public voraussichtlicheLohnsteuer: string;


    constructor(private readonly formBuilder: FormBuilder,
                private readonly validatorService: ValidatorService,
                protected readonly messageService: DatevMessageService,
                protected readonly translateService: TranslateService,
                protected readonly activatedRoute: ActivatedRoute) {
        super(messageService);
    }

    public ngOnInit(): void {
        super.ngOnInit();
        const appEnum = ComponentHelper.getAppEnum(this.activatedRoute.snapshot);

        this.titel = this.translateService.instant('COMMON_UI.FRAGEBOGEN.LOHNSTEUER.VORAUSSICHTLICHE_LOHNSTEUER.TITEL');
        this.hinweis = this.translateService.instant('COMMON_UI.FRAGEBOGEN.LOHNSTEUER.VORAUSSICHTLICHE_LOHNSTEUER.HINWEIS');
        this.voraussichtlicheLohnsteuer = this.translateService.instant(
            'COMMON_UI.FRAGEBOGEN.LOHNSTEUER.VORAUSSICHTLICHE_LOHNSTEUER.VORAUSSICHTLICHE_LOHNSTEUER'
        );

        if (appEnum === AppNameEnum.FragebogenKapG || appEnum === AppNameEnum.FragebogenKapGAus) {
            this.titel = this.translateService.instant('COMMON_UI.FRAGEBOGEN.LOHNSTEUER.VORAUSSICHTLICHE_LOHNSTEUER_KAPG.TITEL');
            this.voraussichtlicheLohnsteuer = this.translateService.instant(
                'COMMON_UI.FRAGEBOGEN.LOHNSTEUER.VORAUSSICHTLICHE_LOHNSTEUER_KAPG.VORAUSSICHTLICHE_LOHNSTEUER'
            );
        }

    }

    protected createForm(): void {
        const MAX_LENGTH = 9;
        this.form = this.formBuilder.group({
            voraussichtlicheLohnsteuer: [
                this.data.voraussichtlicheLohnsteuer, [
                    this.validatorService.maxLength(MAX_LENGTH),
                    this.validatorService.required(),
                    this.validatorService.pattern(ValidationPattern.VOLLER_POSITIVER_GELDBETRAG,
                        this.translateService.instant('COMMON_UI.VALIDATION.VOLLER_POSITIVER_GELDBETRAG_PATTERN'))
                ]]
        });
    }

}
